import { render, staticRenderFns } from "./SaveAsProfileModal.vue?vue&type=template&id=61259e3c&scoped=true"
import script from "./SaveAsProfileModal.vue?vue&type=script&lang=ts"
export * from "./SaveAsProfileModal.vue?vue&type=script&lang=ts"
import style0 from "./SaveAsProfileModal.vue?vue&type=style&index=0&id=61259e3c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61259e3c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61259e3c')) {
      api.createRecord('61259e3c', component.options)
    } else {
      api.reload('61259e3c', component.options)
    }
    module.hot.accept("./SaveAsProfileModal.vue?vue&type=template&id=61259e3c&scoped=true", function () {
      api.rerender('61259e3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modals/SaveAsProfileModal.vue"
export default component.exports